export default __webpack_public_path__ + "static/media/lamp_and_books.4432ff5f.png";